/** Dev2 inbound Twilio numbers — update here when Ops rotates test lines (not fp-api env). */
export const DEV2_TWILIO_TO_BY_DEVICE = {
  onx: '+14067976900',
  oxr: '+16199754632',
};

/** Dev2 PHP script path for inbound Twilio (SOS / SMS). */
export const DEV2_TWILIO_HOOK_PATH_BY_PRODUCT = {
  onx: '/cron-onx-maps-sos.php',
  oxr: '/cron-receive-twilio-sms-hook.php',
};

export const DEV2_TWILIO_DEBUG_QUERY = 'isDebug=1';

/** Static Twilio metadata (from production-shaped samples); swap SIDs in fp-api if needed. */
const DEV2_TWILIO_FORM_DEFAULTS = {
  ToCountry: 'US',
  ToState: 'CA',
  ToCity: 'SAN DIEGO',
  ToZip: '92134',
  FromCountry: 'US',
  FromState: '',
  FromCity: '',
  FromZip: '',
  SmsStatus: 'received',
  NumMedia: '0',
  NumSegments: '1',
  ApiVersion: '2010-04-01',
  AccountSid: 'AC0d29cf7f1b472f9e0fde4a95289dc0af',
  MessagingServiceSid: 'MGb6fdcc76cea36a31f60d0d85b81fae5d',
};

const DEV2_PLACEHOLDER_SMS_SID = 'SM00000000000000000000000000000001';

/** Example Android short link (server follows redirect for coords). */
const DEV2_ANDROID_GOO_GL_SAMPLE = 'https://maps.app.goo.gl/JwbQBCCC6xRHKuQh8?g_st=a';

const DEV2_ZOLEO_MAP_SAMPLE = 'http://sms2zoleo.com/0PdUN';

const DEV2_GARMIN_INREACH_PATH_SAMPLE = 'gFYoZrwAsyjjvxNRJwFkdBw';

/** Default SOS / preset coords (Orlando, FL). */
export const DEV2_DEFAULT_SOS_LAT = 28.5383;
export const DEV2_DEFAULT_SOS_LNG = -81.3792;

/** Inbound Twilio device sample — drives Twilio `Body` for SOS/SMS. */
export const DEV2_INBOUND_DEVICE_OPTIONS = [
  { value: 'onxmaps', label: 'onX Maps' },
  { value: 'garmin', label: 'Garmin' },
  { value: 'apple', label: 'Apple' },
  { value: 'android', label: 'Android' },
  { value: 'zoleo', label: 'Zoleo' },
  { value: 'iridium', label: 'Iridium' },
];

/** @deprecated use DEV2_INBOUND_DEVICE_OPTIONS */
export const DEV2_SMS_PRESET_OPTIONS = DEV2_INBOUND_DEVICE_OPTIONS;

export function defaultInboundDeviceForProduct(deviceType) {
  return deviceType === 'onx' ? 'onxmaps' : 'garmin';
}


export const DEV2_DEVICE_TYPE_OPTIONS = [
  { value: 'onx', label: 'onX' },
  { value: 'oxr', label: 'OXR' },
];

export function defaultDev2DeviceTypeForParent(parent) {
  const p = String(parent || '').trim().toUpperCase();
  if (p === 'ONX MAPS') return 'onx';
  if (p === 'OXR DTC') return 'oxr';
  return 'onx';
}

export function dev2TwilioToForDeviceType(deviceType) {
  return DEV2_TWILIO_TO_BY_DEVICE[deviceType] || DEV2_TWILIO_TO_BY_DEVICE.onx;
}

export function dev2TwilioHookPathForProduct(deviceType) {
  return DEV2_TWILIO_HOOK_PATH_BY_PRODUCT[deviceType] || DEV2_TWILIO_HOOK_PATH_BY_PRODUCT.onx;
}

export const DEV2_ONX_BUBBLE_ID = 'onX App';

export const DEV2_DEFAULT_ACCOUNT_NUMBER = '005237968';

export const DEV2_DEFAULT_OXR_BUBBLE_ID = '1789970230854x345980513804847300';

export const DEV2_DEFAULT_PRODUCT = 'oxr';

export const DEV2_SCHEDULE_FIRST_NAME = 'Ops';

export const DEV2_SCHEDULE_LAST_NAME = 'Test';

export function defaultBubbleIdForDeviceType(deviceType) {
  if (deviceType === 'onx') return DEV2_ONX_BUBBLE_ID;
  return DEV2_DEFAULT_OXR_BUBBLE_ID;
}

/** `testingDate` is UTC wall time, ISO without Z/offset (Device Tests list convention). */
export const DEV2_TESTING_DATE_TIMEZONE = 'UTC';

export function dev2TestingDateForSchedule() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}T${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
}

export function resolveDev2SosCoordinates(latitude, longitude) {
  const lat = String(latitude ?? '').trim();
  const lng = String(longitude ?? '').trim();
  return {
    lat: lat !== '' && !Number.isNaN(Number(lat)) ? Number(lat) : DEV2_DEFAULT_SOS_LAT,
    lng: lng !== '' && !Number.isNaN(Number(lng)) ? Number(lng) : DEV2_DEFAULT_SOS_LNG,
  };
}

/**
 * Twilio `Body` only (device detection) — shapes from OXR cron / production samples.
 * Uses account + lat/lng fields where applicable.
 */
export function buildDev2SmsBodyPreset(preset, accountNumber, latitude, longitude) {
  const acct = String(accountNumber ?? '').trim() || '551050256';
  const { lat, lng } = resolveDev2SosCoordinates(latitude, longitude);

  switch (preset) {
    case 'onxmaps':
      return `Emergency SOS\nID: ${acct}\nCoordinates: ${lat}, ${lng}`;
    case 'apple':
      return `https://maps.apple.com/?ll=${lat},${lng}&q=Location`;
    case 'android':
      return DEV2_ANDROID_GOO_GL_SAMPLE;
    case 'garmin':
      return `SOS Emergency Response Requested! Account Number: ${acct} inreachlink.com/${DEV2_GARMIN_INREACH_PATH_SAMPLE}  (${lat}, ${lng}) `;
    case 'zoleo':
      return `SOS help needed   (${lat},${lng}) Map: ${DEV2_ZOLEO_MAP_SAMPLE}`;
    case 'iridium':
      return `EMERGENCY/Lat+${lat}(stdv 0075)/Lon${lng}(stdv 0075)/Alt+964 ft(stdv 0075)/GPS sats 04/2012-06-15 15:37UTC/Batt 86%/Lang en/Iridium user`;
    default:
      return '';
  }
}

/** Pass/deviation reply: append is exactly one digit → Twilio `Body` is only that digit. */
export function isDev2ReplyOnlyAppend(bodyAppend) {
  const extra = String(bodyAppend ?? '').trim();
  return /^\d$/.test(extra);
}

/** Twilio `Body`: device template, or reply-only digit, or template + suffix. */
export function buildDev2InboundMessageBody(
  preset,
  accountNumber,
  latitude,
  longitude,
  bodyAppend = ''
) {
  const extra = String(bodyAppend ?? '').trim();
  if (isDev2ReplyOnlyAppend(extra)) return extra;
  const base = buildDev2SmsBodyPreset(preset, accountNumber, latitude, longitude);
  if (!extra) return base;
  return `${base}${extra}`;
}

/**
 * Full Twilio inbound webhook fields for fp-api → Dev2 (From + Body drive device logic).
 */
export function buildDev2TwilioWebhookPayload({ deviceType, from, to, body }) {
  const messageSid = DEV2_PLACEHOLDER_SMS_SID;
  const form = {
    ...DEV2_TWILIO_FORM_DEFAULTS,
    SmsMessageSid: messageSid,
    SmsSid: messageSid,
    MessageSid: messageSid,
    From: from,
    To: to,
    Body: body,
  };
  return buildDev2PassthroughPayload(deviceType, form);
}

const TWILIO_WEBHOOK_META_KEYS = new Set(['path', 'query', 'form']);

/** Single-line `application/x-www-form-urlencoded` body (Twilio field names only). */
export function twilioWebhookFormFieldsToUrlEncoded(formFields) {
  const params = new URLSearchParams();
  Object.entries(formFields).forEach(([key, value]) => {
    if (TWILIO_WEBHOOK_META_KEYS.has(key)) return;
    if (value === undefined || value === null) return;
    params.set(key, String(value));
  });
  return params.toString();
}

export function parseTwilioWebhookUrlEncoded(urlEncodedLine) {
  const params = new URLSearchParams(String(urlEncodedLine ?? '').trim());
  const form = {};
  params.forEach((value, key) => {
    form[key] = value;
  });
  return form;
}

export function isDev2UrlEncodedTwilioWebhook(raw) {
  const line = String(raw ?? '').trim();
  if (!line) return false;
  return line.includes('ToCountry=') && /(?:^|&)Body=/.test(line);
}

export function twilioFormFieldsFromWebhookPayload(payload) {
  const form = {};
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (TWILIO_WEBHOOK_META_KEYS.has(key) || key === 'form') return;
    if (value === undefined || value === null) return;
    form[key] = String(value);
  });
  return form;
}

/**
 * fp-api passthrough: path + query + Twilio fields (top-level and nested `form`, per backend spec).
 */
export function buildDev2PassthroughPayload(deviceType, twilioFormFields) {
  const form = { ...twilioFormFields };
  return {
    path: dev2TwilioHookPathForProduct(deviceType),
    query: DEV2_TWILIO_DEBUG_QUERY,
    ...form,
    form,
  };
}

/** fp-api JSON from the SMS textarea (full urlencoded Twilio webhook line). */
export function buildDev2ApiPayloadFromTwilioWebhook(deviceType, urlEncodedLine) {
  const form = parseTwilioWebhookUrlEncoded(urlEncodedLine);
  return buildDev2PassthroughPayload(deviceType, form);
}

export function buildDev2InboundWebhookPayload({
  deviceType,
  from,
  to,
  preset,
  accountNumber,
  latitude,
  longitude,
  bodyAppend = '',
}) {
  const body = buildDev2InboundMessageBody(
    preset,
    accountNumber,
    latitude,
    longitude,
    bodyAppend
  );
  return buildDev2TwilioWebhookPayload({ deviceType, from, to, body });
}

export function buildDev2InboundWebhookUrlEncoded(params) {
  const payload = buildDev2InboundWebhookPayload(params);
  const twilioForm = payload.form ?? twilioFormFieldsFromWebhookPayload(payload);
  return twilioWebhookFormFieldsToUrlEncoded(twilioForm);
}

/** Build full urlencoded webhook from current form values + message Body. */
export function buildDev2TwilioWebhookUrlEncoded({ deviceType, from, to, body }) {
  const payload = buildDev2TwilioWebhookPayload({ deviceType, from, to, body });
  const twilioForm = payload.form ?? twilioFormFieldsFromWebhookPayload(payload);
  return twilioWebhookFormFieldsToUrlEncoded(twilioForm);
}

/** Best-effort E.164 for member phone fields from Global Search. */
export function normalizeE164Phone(phone) {
  const raw = String(phone ?? '').trim();
  if (!raw) return '';
  if (raw.startsWith('+')) {
    const digits = raw.slice(1).replace(/\D/g, '');
    return digits ? `+${digits}` : '';
  }
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  return digits ? `+${digits}` : '';
}
